import { render } from "./ClassAccounting.vue?vue&type=template&id=cb8be934&scoped=true"
import script from "./ClassAccounting.vue?vue&type=script&lang=js"
export * from "./ClassAccounting.vue?vue&type=script&lang=js"

import "./ClassAccounting.vue?vue&type=style&index=0&id=cb8be934&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc\\Documents\\projets\\school_app_front_novation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb8be934"]])

export default __exports__